import React, { Component } from 'react'
import moment from 'moment'

const dateFormat = 'YYYY/MM/DD HH:mm'

class PublicIssueSimpleTable extends Component {
    render() {
        return (
          <table style={{textAlign: 'left', verticalAlign: 'top'}}>
              <tbody>
                  <tr>
                      <th style={{minWidth: '120px'}}>Tipo</th>
                      <td>{this.props.data.issue_type}</td>
                  </tr>
                  <tr>
                      <th>ID do Registo</th><td>{this.props.data.id}</td>
                  </tr>
                  <tr>
                      <th>Programa</th><td>{this.props.data.programa}</td>
                  </tr>
                  <tr>
                      <th>Local</th><td>{this.props.data.address}</td>
                  </tr>
                  <tr>
                      <th>Praia</th><td>{this.props.data.praia}</td>
                  </tr>
                  <tr>
                      <th>Freguesia</th><td>{this.props.data.freguesia}</td>
                  </tr>
                  <tr>
                      <th>Concelho</th><td>{this.props.data.concelho}</td>
                  </tr>
                  <tr>
                      <th>Distrito</th><td>{this.props.data.distrito}</td>
                  </tr>
                  <tr>
                      <th>ARH</th><td>{this.props.data.arh}</td>
                  </tr>
                  <tr>
                      <th>Latitude (Web Mercator, EPSG:3857)</th><td>{this.props.data.lat}</td>
                  </tr>
                  <tr>
                      <th>Longitude (Web Mercator, EPSG:3857)</th><td>{this.props.data.lon}</td>
                  </tr>
                  <tr>
                      <th>Data da Ocorrência</th>
                      { this.props.data.data_ocorrencia_tipo === 0 ? (
                        <td>{moment(this.props.data.data_ocorrencia).format(dateFormat)}</td>
                      ) : (
                          <td><em>Indeterminada</em></td>
                      ) }
                  </tr>
                  <tr>
                      <th>Data do Registo</th><td>{moment(this.props.data.data_registo_local).format(dateFormat)}</td>
                  </tr>

                  { this.props.data.id ? (
                      <tr>
                          <th>Data do Registo no Sistema</th>
                          <td>{moment(this.props.data.data_registo).format(dateFormat)}</td>
                      </tr>
                  ) : null}

                  <tr>
                      <th>Email</th><td>{this.props.data.email}</td>
                  </tr>

                  { this.props.data.obs ? (
                      <tr>
                          <th>Observações</th>
                          <td>{this.props.data.obs}</td>
                      </tr>
                  ) : null }

              </tbody>
          </table>
        )
    }
}

export default PublicIssueSimpleTable;



// WEBPACK FOOTER //
// ./src/components/PublicIssueSimpleTable.js